module.exports = __webpack_public_path__ + "img/bigdata.61cb6286.jpg";